<template>
  <div class="app-container">
    <div class="filter-container">
      时间段
      <el-date-picker
         v-model="start_datetime"
            type="date"
            value-format="yyyy-MM-dd"
        class="filter-item"
        placeholder="开始日期"
      ></el-date-picker>至
      <el-date-picker
         v-model="end_datetime"
            type="date"
            value-format="yyyy-MM-dd"
        class="filter-item"
        placeholder="结束日期"
      ></el-date-picker>
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入用户名/电话"
        style="width: 200px;"
        class="filter-item"
        clearable
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="third"
        v-if="type==1"
      >搜索</el-button>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        v-else
      >搜索</el-button>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="他的下级" name="first">
        <div style="margin-bottom:10px">     <download-excel
        :fields="u_json_fields"
        :fetch="postSubordinate"
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
         this.nickname+'的下级'
        "
        type="xls"
        worksheet= "他的下级"
        name="他的下级.xls"
      >
        <el-button type="success"> 导出他的下级 </el-button>
      </download-excel></div>
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">{{ scope.$index+1}}</template>
          </el-table-column>
          <el-table-column label="头像" min-width="110" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" class="user-avatar" />
            </template>
          </el-table-column>
          <el-table-column label="昵称" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.nickname }}</template>
          </el-table-column>
          <el-table-column label="联系电话" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column label="性别" min-width="110" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">未设置</span>
              <span v-else-if="scope.row.gender == 1">男</span>
              <span v-else-if="scope.row.gender == 2">女</span>
            </template>
          </el-table-column>
          <el-table-column label="是否实名" min-width="110" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.is_certification == 0">
                <el-tag type="info">否</el-tag>
              </div>
              <div v-else-if="scope.row.is_certification == 1">
                <el-tag type="success">是</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="关注" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.follow_count }}</template>
          </el-table-column>
          <el-table-column label="粉丝" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.fans_count }}</template>
          </el-table-column>
          <el-table-column align="center" prop="created_at" label="注册时间" min-width="200">
            <template slot-scope="scope">
              <i class="el-icon-time" />
              <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="updated_at" label="最新活跃时间" min-width="200">
            <template slot-scope="scope">
              <i class="el-icon-time" />
              <span>{{ scope.row.updated_at }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.page"
            :page-sizes="[10,20,30, 50]"
            :page-size="listQuery.limit"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="他的下下级" name="second" v-if="this.$route.query.isProxy==1">
        <div style="margin-bottom:10px">     <download-excel
        :fields="u_json_fields"
        :fetch="postSubordinate"
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
         this.nickname+'的下下级'
        "
        type="xls"
        worksheet= "他的下下级"
        name="他的下下级.xls"
      >
        <el-button type="success"> 导出他的下下级 </el-button>
      </download-excel></div>
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">{{ scope.$index+1}}</template>
          </el-table-column>
          <el-table-column label="头像" min-width="110" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" class="user-avatar" />
            </template>
          </el-table-column>
          <el-table-column label="昵称" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.nickname }}</template>
          </el-table-column>
          <el-table-column label="联系电话" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column label="性别" min-width="110" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">未设置</span>
              <span v-else-if="scope.row.gender == 1">男</span>
              <span v-else-if="scope.row.gender == 2">女</span>
            </template>
          </el-table-column>
          <el-table-column label="上级昵称" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.parent.nickname }}</template>
          </el-table-column>
          <el-table-column label="上级头像" min-width="110" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.parent.avatar" class="user-avatar" />
            </template>
          </el-table-column>
          <el-table-column label="上级电话" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.parent.phone }}</template>
          </el-table-column>
          <el-table-column align="center" prop="created_at" label="注册时间" min-width="200">
            <template slot-scope="scope">
              <i class="el-icon-time" />
              <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="updated_at" label="最新活跃时间" min-width="200">
            <template slot-scope="scope">
              <i class="el-icon-time" />
              <span>{{ scope.row.updated_at }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.page"
            :page-sizes="[10,20,30, 50]"
            :page-size="listQuery.limit"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="他的奖励" name="third">
        <div class="fenxiao">总奖励：{{price}}</div>
         <div  style=" display: inline-block;">     <download-excel
        :fields="a_json_fields"
        :fetch="postReward"
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="'总奖励：'+this.price
        "
        type="xls"
        worksheet= "他的奖励"
        name="他的奖励.xls"
      >
        <el-button type="success"> 导出他的奖励 </el-button>
      </download-excel></div>
        <el-table
          v-loading="listLoading"
          :data="rewardList"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">{{ scope.$index+1}}</template>
          </el-table-column>
          <el-table-column label="订单号" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.order_no}}</template>
          </el-table-column>
          <el-table-column label="昵称" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.user.nickname}}</template>
          </el-table-column>
          <el-table-column label="头像" min-width="150" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.user.avatar" alt style="width: 110px;" />
            </template>
          </el-table-column>
          <el-table-column label="联系电话" min-width="110" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.user.gender == 0">未设置</span>
              <span v-else-if="scope.row.user.gender == 1">男</span>
              <span v-else-if="scope.row.user.gender == 2">女</span>
            </template>
          </el-table-column>
          <el-table-column label="奖励" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.order_reward_log.reward_price }}</template>
          </el-table-column>
          <el-table-column label="时间" min-width="110" align="center">
            <template slot-scope="scope">{{ scope.row.created_at }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.page"
            :page-sizes="[10,20,30, 50]"
            :page-size="listQuery.limit"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import request from "@/utils/request";
import Vue from "vue";
import downloadExcel from "vue-json-excel";
export default {
  components: { downloadExcel },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: null,
      rewardList: null,
      type: 0,
      total: null,
      listLoading: true,
      activeName: "first",
      nickname:"",
      user_id: this.$route.query.userId,
      price: null,
      //用户
      u_json_fields: {
        "昵称 ": "nickname",
        "联系电话 ": "phone",
        "性别 ": {
          field: "gender",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "未设置"
            }else if(value==1){
              return "男"
            }else if(value==2){
              return "女"
            }
          },
        },
        "是否实名 ": {
          field: "is_certification",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "否"
            }else if(value==1){
              return "是"
            }
          },
        },
        "关注": "follow_count",
        "粉丝": "fans_count",
        "注册时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
         "最新活跃时间 ": {
          field: "updated_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        },
        //他的奖励
        a_json_fields: {
        "订单号 ": {
          field: "order_no",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "昵称 ": "user.nickname",
        "联系电话 ": "phone",
        "奖励 ": {
          field: "order_reward_log.reward_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
      },
      listQuery: {
        page: 1,
        limit: 10,
        start_date: "",
        end_date: "",
        subordinate: "",
        keyword: "",
        user_id: ""
      },
      formInline: {
        user: "",
        region: ""
      },
       start_datetime: "",
      end_datetime: "",
    };
  },
  created() {
    this.listQuery.user_id = this.$route.query.userId;
    this.nickname = this.$route.query.nickname;
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
this.listQuery.start_date = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      request({
        url: "/api/backend/subordinate",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleClick(tab) {
      this.listQuery.page = 1;
      if (tab.name == "first") {
        this.type = 0;
        this.first();
      } else if (tab.name == "second") {
        this.type = 0;
        this.second();
      } else {
        this.type = 1;
        this.third();
        return;
      }
      this.getList();
    },

    first() {
      this.listQuery.subordinate = "";
    },

    second() {
      this.listQuery.subordinate = 2;
    },
    third() {
      request({
        url: "/api/backend/user/reward",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.rewardList = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
        this.price = response.data.price;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/user/forbid",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    startPost() {
      this.loading = true;
    },
    endPost() {
      this.loading = false;
    },
      postSubordinate(){
     this.listLoading = true
     if(this.listQuery.subordinate==2){
       this.u_json_fields={
        "昵称 ": "nickname",
        "联系电话 ": "phone",
        "性别 ": {
          field: "gender",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "未设置"
            }else if(value==1){
              return "男"
            }else if(value==2){
              return "女"
            }
          },
        },
        "上级昵称 ": "parent.nickname",
        "上级电话 ": "parent.phone",
        "是否实名 ": {
          field: "is_certification",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "否"
            }else if(value==1){
              return "是"
            }
          },
        },
        "关注": "follow_count",
        "粉丝": "fans_count",
        "注册时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
         "最新活跃时间 ": {
          field: "updated_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        }
     }else{
       this.u_json_fields={
        "昵称 ": "nickname",
        "联系电话 ": "phone",
        "性别 ": {
          field: "gender",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "未设置"
            }else if(value==1){
              return "男"
            }else if(value==2){
              return "女"
            }
          },
        },
        "是否实名 ": {
          field: "is_certification",
          //自定义回调函数
          callback: (value) => {
            if(value==0){
              return "否"
            }else if(value==1){
              return "是"
            }
          },
        },
        "关注": "follow_count",
        "粉丝": "fans_count",
        "注册时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
         "最新活跃时间 ": {
          field: "updated_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        }
     }
     this.listQuery.start_date = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      return request({
        url: "/api/backend/postSubordinate",
        method: "get",
        params: this.listQuery
      })
        .then((result) => {
          var json_data = result.data;

          console.log(json_data);
          
          return json_data;
          
        })
        .catch((err) => {
          console.log(err);
        }).finally(()=>{
this.listLoading = false;
        });
    },
    postReward(){
     this.listLoading = true
     this.listQuery.all=1
     this.listQuery.start_date = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      return request({
   url: "/api/backend/user/reward",
        method: "get",
        params: this.listQuery
      })
        .then((result) => {
          var json_data = result.data.data;
          console.log(json_data);  
          return json_data;
          
        })
        .catch((err) => {
          console.log(err);
        }).finally(()=>{
this.listLoading = false;
        });
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
 .fenxiao {
    display: inline-block;
    padding: 20px 30px;
    margin-right: 20px;
    background-color: rgba(255, 0, 0, 0.438);
    color: #ffffff;
    margin-bottom: 10px;
    border-radius: 30px;
  }
</style>
